import './index.css';
import './w3.css';
import './common/globalStyles.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryCache, MutationCache, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import Bowser from 'bowser';
import { appConfig } from './config';
import { Client, shouldRetry, handleError, setAuthHeader } from './apis/common';
import { rootReducer } from 'redux/reducers';
import { configureStore } from 'redux/store';
import { Auth } from 'components/shared/Auth';
import Auth0 from './Auth0';
import App from './App';

function isValidBrowser() {
  const allowedPlatforms = ['desktop', 'tablet'];
  const browser = Bowser.getParser(window.navigator.userAgent);

  // block mobile users
  return allowedPlatforms.includes(browser.getPlatformType().toLowerCase());
}

const auth = new Auth0();

/**
 * Please, do not use it. Temporary solution to access auth in actions
 * @deprecated
 */
window.__APP_AUTH = auth;

const history = createBrowserHistory();

if (!isValidBrowser()) {
  history.replace('/error/unsupported-browser');
}

/**
 * Please, do not use it. Temporary solution to access history in actions
 * @deprecated
 */
window.__APP_HISTORY = history;

Client.init({
  baseUrl: appConfig.apiBaseUrl,
  prepare: (init) => setAuthHeader(init, { auth })
});

const queryCache = new QueryCache({
  onError: (error, query) => handleError(query.state.fetchFailureCount, error, { history, queryClient })
});
const mutationCache = new MutationCache({
  onError: (error, variables, context, mutation) =>
    handleError(mutation.state.failureCount, error, { history, queryClient })
});
const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      cacheTime: 5 * 60 * 1000,
      retry: (failureCount, error) => shouldRetry(failureCount, error, { auth })
    },
    mutations: {
      cacheTime: 5 * 60 * 1000,
      retry: (failureCount, error) => shouldRetry(failureCount, error, { auth })
    }
  }
});

const store = configureStore({
  reducer: rootReducer,
  thunkExtraArgument: {
    auth,
    history
  }
});

ReactDOM.render(
  <Provider store={store}>
    <Auth auth={auth}>
      <QueryClientProvider client={queryClient}>
        <Router history={history}>
          <App />
        </Router>
        <ReactQueryDevtools position="bottom-right" />
      </QueryClientProvider>
    </Auth>
  </Provider>,
  document.getElementById('root')
);
